module.exports = __webpack_public_path__ + "public/img/sig-new.1d153ae4.png";